import react from 'react';
import {TableCell, TableHead, TableRow, Typography} from "@mui/material";
import React from "react";

export const QuerySummaryTableHeaders = () => {

    return (
        <TableHead>
            <TableRow
                sx={{
                    '& > *': {paddingTop: '4px !important', paddingBottom: '4px !important'},
                }}
            >
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        W-L
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        ATS W-L
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        Avg Line
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        Avg ATS ∆
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        Avg Total
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        OV-UN
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        Avg OU ∆
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="subtitle2">
                        Avg Score
                    </Typography>
                </TableCell>
            </TableRow>
        </TableHead>
    )
}